export const setBackupProductCode = (state, { productCode }) => ({
  ...state,
  productCode,
})
